// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"261":"d7e6818e","390":"994a925e","399":"05f16606","415":"bd3f39f6","453":"7e0798bc","482":"60ea0563","643":"f0e3a640","694":"bc73ce7d","774":"968f08ba"}[chunkId] + ".chunk.css";
};